<template>
  <div class="additional-fee-insurance-form">
    <bg-text>Informasi Asuransi</bg-text>
    <bg-text size="body-2">
      Informasi ini akan ditampilkan ke penyewa di halaman Booking Form
    </bg-text>

    <bg-field label="Total Manfaat Asuransi" class="mt-16">
      <bg-input-price
        v-model="totalCoverageValue"
        placeholder="Masukkan nominal manfaat"
        data-testid="input-total-coverage"
        maxlength="9"
      />
    </bg-field>

    <div class="mt-16 flex justify-space-between align-center">
      <bg-text size="body-1">Cakupan Perlindungan</bg-text>
      <bg-button-icon
        icon="add-plus"
        size="md"
        variant="secondary"
        @click="addCoverageItem"
      >
        Tambah
      </bg-button-icon>
    </div>

    <div
      v-for="(item, index) in coverageItemsValue"
      :key="item.id"
      class="flex align-start mt-8"
    >
      <bg-textarea
        class="additional-fee-insurance-form__coverage-item-input"
        v-model.trim="item.value"
        placeholder="Masukkan cakupan perlindungan"
        rows="1"
        auto-size
        :max-char="100"
      />
      <bg-button-icon
        icon="delete"
        size="md"
        variant="tertiary"
        class="ml-8"
        :disabled="disabledDeleteCoverageItem(index)"
        @click="deleteCoverageItem(index)"
      />
    </div>
  </div>
</template>

<script>
import {
  BgText,
  BgTextarea,
  BgField,
  BgInputPrice,
  BgButtonIcon,
} from 'bangul-vue';

export default {
  name: 'AdditionalFeeInsuranceForm',
  components: {
    BgText,
    BgTextarea,
    BgField,
    BgInputPrice,
    BgButtonIcon,
  },
  props: {
    totalCoverage: {
      type: [String, Number],
      required: true,
    },
    coverageItems: {
      type: Array,
      required: true,
    },
    minimumCoverageItemsCount: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      totalCoverageValue: this.totalCoverage,
      coverageItemsValue: this.coverageItems.map((value, index) =>
        this.createCoverageItem(value, index)
      ),
    };
  },
  watch: {
    totalCoverageValue(newVal) {
      this.$emit('update:total-coverage', newVal);
    },
    coverageItemsValue: {
      handler(newVal) {
        this.$emit(
          'update:coverage-items',
          newVal.map(item => item.value)
        );
      },
      deep: true,
    },
  },
  created() {
    this.setInitialCoverageItems();
  },
  methods: {
    createCoverageItem(value = '', index) {
      const idIndex = index ?? this.coverageItemsValue.length;
      const id = `${idIndex}-${Date.now()}`;

      return {
        id,
        value,
      };
    },
    setInitialCoverageItems() {
      if (this.coverageItemsValue.length < this.minimumCoverageItemsCount) {
        const itemsToAdd =
          this.minimumCoverageItemsCount - this.coverageItemsValue.length;

        for (let i = 0; i < itemsToAdd; i++) {
          this.coverageItemsValue.push(this.createCoverageItem());
        }
      }
    },
    deleteCoverageItem(index) {
      if (this.coverageItemsValue.length > this.minimumCoverageItemsCount) {
        this.coverageItemsValue.splice(index, 1);
      } else {
        this.coverageItemsValue.splice(index, 1, this.createCoverageItem());
      }
    },
    addCoverageItem() {
      this.coverageItemsValue.push(this.createCoverageItem());
    },
    disabledDeleteCoverageItem(index) {
      return (
        index < this.minimumCoverageItemsCount &&
        this.coverageItemsValue.length <= this.minimumCoverageItemsCount &&
        (this.coverageItemsValue[index]?.value || '').trim().length === 0
      );
    },
  },
};
</script>

<style lang="scss" scoped src="./AdditionalFeeInsuranceForm.scss"></style>
